function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import dt from "date-and-time";
import dateFormat from "dateformat";
import dateDifference from "date-difference";
import formatDate from "date-difference";
import { DateFormatter } from "noood/util/converters/DateFormatter";

// @formatter:off
// @formatter:on

export var date_util = {
  db_format_input: 'YYYY-MM-DD HH:mm:ss',
  db_format_output: 'yyyy-mm-dd HH:MM:ss',
  formats: {
    src: {
      db_time: "HH:mm:ss"
    },
    output: {
      date: "yyyy-mm-dd",
      short_month: "mmm dd, yy",
      full_month: "mmmm dd, yyyy",
      full_month_and_time: "mmmm dd, yyyy hh:MM TT",
      short_with_time: 'mmm dd, yyyy hh:MMtt'
    },
    extended_output: "dddd, mmmm d, yyyy hh:MM TT"
  },
  days: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
  dayss: ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  /**
   * @param {Date|string<YYYY-MM-DD>|null|undefined} day
   * <br /><strong>null|undefined</strong>: the day will become the current local date. <br />
   * <strong>Date</strong>: an ES6 Date object <br />
   * <strong>string<YYYY-MM-DD></strong>: a string parameter is expected to be in the format 2023-05-25. <br />s
   * @returns {number|null}
   */
  dayOfWeek: function dayOfWeek(day) {
    if (day === void 0 || day === null) {
      return date_util.days.indexOf(date_util.format(date_util.local_date(), "ddd").toUpperCase()) + 1;
    } else {
      if (_typeof(day) === "object") {
        return date_util.days.indexOf(date_util.format(day, "ddd"));
      } else {
        if (day) {
          if (day.trim().length === 3) {
            return date_util.days.indexOf(day.toUpperCase());
          } else {
            return date_util.dayss.indexOf(day.toUpperCase());
          }
        } else return null;
      }
    }
  },
  age: function age(date_1, date_2) {
    return ''; //dt.substract(date_2, dt.parse(date_1, 'YYYY-MM-DD'))
  },
  parse: function parse(dt_, format) {
    return dt.parse(dt_, format !== null && format !== void 0 ? format : 'YYYY-MM-DD');
  },
  /**
   * @returns {Date}
   */
  local_date: function local_date() {
    return Date.today();
  },
  yesterday: function yesterday() {
    return date_util.local_date().add({
      "days": -1
    });
  },
  addMonths: function addMonths(_ref) {
    var months = _ref.months;
    return dt.addMonths(new Date(), months);
  },
  elapsed: function elapsed(datetime) {
    var dt_ = dt.parse(datetime, 'YYYY-MM-DD HH:mm:ss', true);
    return dateDifference(dt_, new Date(), {
      compact: true
    });
  },
  elt_title: function elt_title(datetime) {
    var dt_ = dt.parse(datetime, 'YYYY-MM-DD HH:mm:ss', true);
    return dateFormat(dt_, 'dddd, mmmm d, yyyy hh:MM TT');
  },
  unix_now: function unix_now(to_format) {
    var simple_utc = new Date().toUTCString().substring(5).replace(/GMT/, '').trim();
    var utc_now = dt.parse(simple_utc, 'DD MMM YYYY HH:mm:ss');
    return dateFormat(utc_now, to_format !== null && to_format !== void 0 ? to_format : 'yyyy-mm-dd HH:MM:ss');
  },
  utc_now: function utc_now() {
    var simple_utc = new Date().toUTCString().substring(5).replace(/GMT/, '').trim();
    return dt.parse(simple_utc, 'DD MMM YYYY HH:mm:ss');
  },
  now: function now(to_format) {
    return dateFormat(new Date(), to_format !== null && to_format !== void 0 ? to_format : 'yyyy-mm-dd HH:mm:ss');
  },
  format: function format(dt, _format) {
    return dateFormat(dt, _format);
  },
  max: function max(dts) {
    var max = null;
    dts.forEach(function (the_dt, idx) {
      if (max == null) {
        max = the_dt;
      } else {
        var this_date = date_util.parse(the_dt);
        console.log(this_date);
      }
    });
    return max;
  },
  min: function min(dts) {
    var min = null;
    dts.forEach(function (the_dt, idx) {
      if (min == null) {
        min = the_dt;
      } else {
        var this_date = date_util.parse(the_dt);
        console.log(this_date);
      }
    });
    return min;
  },
  is_after: function is_after(dt1, dt2) {
    return dt1.isAfter(dt2);
  },
  reformat: function reformat(src_dt_str, current_format, desired_format) {
    if (src_dt_str && current_format && desired_format) {
      try {
        var _src_dt_str$toString;
        var parsedDate = date_util.parse(src_dt_str === null || src_dt_str === void 0 || (_src_dt_str$toString = src_dt_str.toString()) === null || _src_dt_str$toString === void 0 ? void 0 : _src_dt_str$toString.trim(), current_format);
        return date_util.format(parsedDate, desired_format);
      } catch (e) {}
    } else return null;
  },
  as_local: function as_local(utc_date_str, return_format) {
    if (utc_date_str != null) {
      var dt_ = dt.parse(utc_date_str, 'YYYY-MM-DD HH:mm:ss', true);
      if (return_format) {
        return date_util.format(dt_, return_format);
      } else {
        return dt_;
      }
    } else return '';
  },
  diff: function diff(lower, higher) {
    var msDiff = dateDifference(lower, higher);
    formatDate();
    return msDiff;
  },
  diffHoursInFractional: function diffHoursInFractional(lower, higher) {
    var minutesDiff = lower.getMinutesBetween(higher);
    return Math.round(minutesDiff / 60 * 100) / 100;
  },
  thisWeekObj: function thisWeekObj() {
    var dayOfWeek = date_util.dayOfWeek();
    var sunday = date_util.local_date().add({
      "days": (dayOfWeek - 1) * -1
    });
    var saturday = date_util.local_date().add({
      "days": 7 - dayOfWeek
    });
    return {
      sunday: sunday,
      saturday: saturday
    };
  },
  convertDbTimeTo12HampmStr: function convertDbTimeTo12HampmStr(dbTimeStr) {
    var _dbTimeStr$split$;
    var finalTimeStr = "";
    var h = dbTimeStr.split(":")[0];
    var _dbTimeStr$split$1$sp = (_dbTimeStr$split$ = dbTimeStr.split(":")[1]) === null || _dbTimeStr$split$ === void 0 ? void 0 : _dbTimeStr$split$.split(" "),
      _dbTimeStr$split$1$sp2 = _slicedToArray(_dbTimeStr$split$1$sp, 2),
      m = _dbTimeStr$split$1$sp2[0],
      ampm = _dbTimeStr$split$1$sp2[1];
    if (Number(h) === 12) {
      finalTimeStr = "12:".concat(m, " pm");
    } else if (Number(h) === 0) {
      finalTimeStr = "12:".concat(m, " am");
    } else if (Number(h) > 12) {
      finalTimeStr = "".concat(Number(h) - 12, ":").concat(m, " pm");
    } else if (Number(h) < 12) {
      finalTimeStr = "".concat(h, ":").concat(m, " am");
    }
    return finalTimeStr;
  },
  date_range2: function date_range2(_ref2) {
    var _date_util$reformat, _end_formatted$trim;
    var start_dt = _ref2.start_dt,
      start_time = _ref2.start_time,
      end_dt = _ref2.end_dt,
      end_time = _ref2.end_time;
    var this_year = new Date().getFullYear();
    var this_month_name = date_util.months[new Date().getMonth()];
    var start_ = start_dt;
    var end_ = end_dt;
    var start_year = date_util.reformat(start_, "YYYY-MM-DD", "yyyy");
    var end_year = date_util.reformat(end_, DateFormatter.SQL_DATE, 'yyyy');
    var start_month = date_util.reformat(start_, "YYYY-MM-DD", "mmmm");
    var end_month = date_util.reformat(end_, DateFormatter.SQL_DATE, 'mmmm');
    var start_day = date_util.reformat(start_, DateFormatter.SQL_DATE, 'dd');
    var end_day = date_util.reformat(end_, DateFormatter.SQL_DATE, 'dd');
    var is_within_this_year = start_year.toString() === this_year.toString();
    var is_within_this_month = start_month.toString().toUpperCase() === this_month_name.toUpperCase();
    var hasEndDate = end_ !== void 0 && end_ !== null;
    var hasStartTime = start_time !== void 0 && start_time !== null;
    var isSameDate = start_dt === (end_dt !== null && end_dt !== void 0 ? end_dt : start_dt);
    var isSameYear = start_year === end_year;
    var isSameMonth = start_month === end_month;
    var isSameDay = start_day === end_day;
    var range = [];
    var start_formatted = date_util.reformat(start_.concat(start_time ? " ".concat(start_time) : ''), 'YYYY-MM-DD'.concat(start_time ? " HH:mm:ss" : ""), 'mmm dd'.concat(!is_within_this_year && isSameYear && !hasEndDate ? ', yyyy' : '').concat(start_time && is_within_this_year ? ',' : '').concat(start_time ? " h:MMtt" : ""));
    var end_formatted = (_date_util$reformat = date_util.reformat((end_ !== null && end_ !== void 0 ? end_ : start_).concat(end_time ? " ".concat(end_time) : ''), 'YYYY-MM-DD'.concat(end_time ? " HH:mm:ss" : ""), ''.concat(hasEndDate ? !isSameDate || hasStartTime ? ' mmm' : '' : '').concat(hasEndDate ? isSameDate ? '' : ' dd' : '').concat(hasEndDate ? !isSameDate && !is_within_this_year ? ', yyyy' : '' : '').concat(hasEndDate && end_time && is_within_this_year ? ',' : '').concat(end_time ? ' h:MMtt' : ''))) === null || _date_util$reformat === void 0 ? void 0 : _date_util$reformat.trim();
    range.push(start_formatted.replace(":00am", "am").replace(":00pm", "pm"));
    if ((end_formatted === null || end_formatted === void 0 || (_end_formatted$trim = end_formatted.trim()) === null || _end_formatted$trim === void 0 ? void 0 : _end_formatted$trim.length) > 0) {
      range.push(end_formatted.replace(":00pm", "pm").replace(":00am", "am"));
    }
    return range.join(' — ');
  },
  is_datetime_format: function is_datetime_format(str) {
    return str.match(/[0-9]{4}(-[0-9]{2}){2} [0-9]{2}(:[0-9]{2}){2}/);
  }
};